import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { flatConstants, flatHelpers, flatModels } from '..';

export const useHouseCompactV2Param = ({
  param,
  enabled = true
}: {
  param: 'CONTRACT' | 'PAYMENT' | 'BOOKING' | 'DEBT' | 'GENERAL' | 'ALL';
  enabled?: boolean;
}) =>
  useQuery<flatModels.IHouse[]>({
    queryKey: [flatConstants.queryKeys.HOUSE_COMPACT_V2_PARAM, param],
    queryFn: async () => {
      const res = await $api.get(`/v1/house/compact/v2/${param}`);

      return res?.data?.data;
    },
    enabled: enabled && flatHelpers.isHouseCompactParam()
  });
